import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EditorContainer } from '../containers/editor/editor.container';
import { AlgebraKiTService } from '../modules/algebrakit/services/algebrakit.service';

/**
 * Prevent that a user navigates away from the exercise editor if the exercise is not valid.
 */
@Injectable({
  providedIn: 'root'
})
export class EditorDeactivateGuard  {
  constructor(
    private akitService: AlgebraKiTService,
    private router: Router
  ){};

  canDeactivate(
    component: EditorContainer,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot):Promise<boolean> {
      return this.akitService.getExerciseManager(this.akitService.getExerciseFromCache()).then(exerciseManager => {
        if(!exerciseManager) return true;
        else {
          let spec = exerciseManager.getExercise();
          this.akitService.setCurrentExercise(spec);
          if(this.akitService.isEmptyExercise(spec)) return true;
          return exerciseManager.inspect().then(_validationResult => _validationResult.valid);
        }
      })
    };
}